<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getExportRequests.length > 0 && $store.getters.getExportRequestsLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'exportsInTable_Id',
            'exportsInTable_createdAt',
            'exportsInTable_name',
            'exportsInTable_pageCount',
            'exportsInTable_pageCurrent',
            'exportsInTable_Status',
            'common_manage',
          ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th>{{ $t('exportsInTable_Id.localization_value.value') }}</th>
            <th>{{ $t('exportsInTable_createdAt.localization_value.value') }}</th>
            <th>{{ $t('exportsInTable_name.localization_value.value') }}</th>
            <th>{{ $t('exportsInTable_pageCount.localization_value.value') }}</th>
            <th>{{ $t('exportsInTable_pageCurrent.localization_value.value') }}</th>
            <th>{{ $t('exportsInTable_Status.localization_value.value') }}</th>
            <th>{{ $t('common_manage.localization_value.value') }}</th>
            <th width="100%" class="hide-1400"></th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getExportRequests" :key="index">
            <td>
              #{{item.id}}
            </td>
            <td>
              {{item.created_at}}
            </td>
            <td>
              <ValueHelper
                  :value="item"
                  :deep="'export_name'"
              />
            </td>
            <td>
              {{item.page_count}}
            </td>
            <td>
              {{item.current_page}}
            </td>
            <td>
              <div v-if="item.status === 'success'"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['exportsInTable_Active'])"></div>
                <StatusIcoBtn class="mr-1" :type="'delivered'"/>
                {{ $t('exportsInTable_Active.localization_value.value') }}
              </div>
              <div v-else
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['exportsInTable_Inactive'])"></div>
                <StatusIcoBtn class="mr-1" :type="'cancel'"/>
                {{ $t('exportsInTable_Inactive.localization_value.value') }}
              </div>
            </td>
            <td class="manage-row">
              <div class="table-right table-manage-list table-manage-list--small">

                <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) "
                               :key="$store.getters.getGlobalUpdateManagerButton">
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_download.localization_value.value')"
                            :type="'proforma'"
                            @click.native="downloadFile(item)"
                    />
                  </template>
                </ManagerButton>
              </div>
            </td>
            <td class="hide-1400"></td>
          </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getExportRequests"
                 :key="index"
            >
              <ExportRequestsTableMobile
                      :item="item"
                      @deleteItem="deleteItem(item.id)"
              />
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getExportRequestsCommonList.next_page_url !== null && $store.getters.getExportRequests.length > 0"
                    @click.native="$emit('showMore')"
                    :count="$store.getters.getExportRequestsCommonList.total - $store.getters.getExportRequestsForPage * $store.getters.getExportRequestsCommonList.current_page < $store.getters.getExportRequestsForPage ?
                    $store.getters.getExportRequestsCommonList.total - $store.getters.getExportRequestsForPage * $store.getters.getExportRequestsCommonList.current_page:
                    $store.getters.getExportRequestsForPage"
            />
          </div>
        </div>

      </div>
    </template>

    <template
            v-if="$store.getters.getExportRequestsLoading === false && $store.getters.getExportRequests.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>


  </div>
</template>

<script>
  import StatusIcoBtn from "../../../../../../UI/status/StatusIcoBtn/StatusIcoBtn";
  import ManagerButton from "../../../../../../UI/buttons/ManagerButton/ManagerButton";
  import LinkButton from "../../../../../../UI/buttons/LinkButton/LinkButton";
  import ShowMore from "../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import {mixinDetictingMobile} from '../../../../../../../mixins/mobileFunctions'
  import NoResult from "../../../../../../coreComponents/NoResult/NoResult";
  import ExportRequestsTableMobile from "./ExportRequestsTableMobile/ExportRequestsTableMobile";
  import {routeFilter} from "@/mixins/routeFilterMixins/routeFilter";
  import ValueHelper from "@/components/coreComponents/ValueHelper/ValueHelper";

  export default {
    name: "ExportRequestsTable",
    components: {
      ValueHelper,
      ExportRequestsTableMobile,
      NoResult,
      StatusIcoBtn,
      ManagerButton,
      LinkButton,
      ShowMore,
    },

    mixins: [mixinDetictingMobile, routeFilter],

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        itemId: -1,
        showFilter: false,
        isMobile: false,

        showContent: false,

        // isModalProductsToWarehouse: false,

        show1: false,
        show2: false,


      }
    },

    methods: {

      downloadFile(item) {
        if(!item?.file_entities) {
          return
        }

        this.$store.dispatch('downloadFileFromServer', item.file_entities.id).then(response => {
          console.log(response);
          this.createDownloadLink({data: response.data, name: `${this.$t('exportsInTable_fileName.localization_value.value')}.${item.file_entities.extension}`, type: item.file_entities.extension})
        })
      },

      deleteItem(id) {
        let text = {
          title: 'common_deleteConfirm',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {
          this.$store.dispatch('deleteExportRequests', id).then(response => {
            if (this._.has(response, 'data') && response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {
              this.openNotify('success', 'common_notificationRecordDeleted')
              this.$emit('reload')
            } else {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }
</script>

<style scoped lang="scss">
  .comment-row {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 1400px) {
    .comment-row {
      width: 100px;
    }
  }

  .table-manage-list .manager-btn {
    width: 200px;
  }

  @media (max-width: 1400px) {
    .table-manage-list .manager-btn {
      width: 100px;
    }

    .user-field-admin {
      flex-wrap: wrap;
      display: flex;
    }

    .hide-1400 {
      display: none;
    }
  }

  /*.site-table thead th:first-child,*/
  /*.site-table tbody td:first-child {*/
  /*padding-right: 0;*/
  /*}*/

  /*.site-table thead th:nth-child(2),*/
  /*.site-table tbody td:nth-child(2) {*/
  /*padding-left: 0;*/
  /*}*/

  /*.site-table thead th:last-child,*/
  /*.site-table tbody td:last-child {*/
  /*padding-right: 0;*/
  /*}*/

  .small-table th,
  .small-table td {
    white-space: nowrap;
  }

  .size-24 {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }


</style>
